<template>
  <span class="marker-acronym" :style="{ backgroundColor: acronym.color }">
    {{ acronym.label }}
  </span>
</template>

<script>
export default {
  name: 'MarkerAcronym',
  props: {
    acronym: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.marker-acronym {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 2px 4px;
  min-width: 20px;
  min-height: 14px;
  line-height: 1;
  color: $generic-color-text-alt;
  font-size: $font-size-xs;
}
</style>
